export default __webpack_public_path__ + "static/media/FailedPurchase.d61a1489.png";